import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=82a461f6&scoped=true"
import script from "./OAuthCallback.vue?vue&type=script&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./OAuthCallback.vue?vue&type=style&index=0&id=82a461f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a461f6",
  null
  
)

export default component.exports